export enum AnalyticsSource {
	COMMENTS_PANEL = 'commentsPanel',
	MEDIA_VIEWER_SIDEBAR = 'mediaViewerSidebar',
	STANDALONE = 'standalone',
	PAGE_FOOTER = 'pageFooter',
}

export enum ActionName {
	REOPEN_COMMENT = 'reopenComment',
}

export enum CommentType {
	INLINE = 'inline',
	GENERAL = 'general',
	PAGE = 'page',
}
